module.exports = __webpack_public_path__ + "static/media/banner@2x.e26cc252.png";